import * as THREE from './three/three.module.js';

const frontVec = new THREE.Vector3(0,0,1);
const upVec = new THREE.Vector3(0,1,0);
const tmpVec = new THREE.Vector3(0,0,0);
const tmpQ = new THREE.Quaternion(0,0,0,1);

export class Transformation3 {
    quaternion;
    position;

    constructor(p = null, q = null) {

        this.m3 = new Array(9);
        this.quaternion = q ? new THREE.Quaternion(q.x,q.y, q.z, q.w ) : new THREE.Quaternion();
        this.position   = p ? { x: p.x, y: p.y, z: p.z } : { x: 0, y: 0, z: 0 };
        this.computeMatrix();
    }

    identity(){

        this.quaternion.x=0.0;
        this.quaternion.y=0.0;
        this.quaternion.z=0.0;
        this.quaternion.w=1.0;

        this.position.x=0;
        this.position.y=0;
        this.position.z=0;
        

    }

    setPos(x, y, z) {
        this.position.x = x !== null ? x : this.position.x;
        this.position.y = y !== null ? y : this.position.y;
        this.position.z = z !== null ? z : this.position.z;
    }

    set(p, q = null) {

        if(p != null) {
            this.position.x = p.x;
            this.position.y = p.y;
            this.position.z = p.z;
        }

        if(q != null) {
            this.quaternion.x = q.x;
            this.quaternion.y = q.y;
            this.quaternion.z = q.z;
            this.quaternion.w = q.w;
            this.computeMatrix();
        }
    }

    mulquat(q, o) {
        // Q1 * Q2 = [w1 * w2 - dot(v1, v2), w1 * v2 + w2 * v1 + cross(v1, v2)]
          // Not commutative because cross(v1, v2) != cross(v2, v1)!
  
        const w1 = this.quaternion.w;
        const x1 = this.quaternion.x;
        const y1 = this.quaternion.y;
        const z1 = this.quaternion.z;
  
        const w2 = q.w;
        const x2 = q.x;
        const y2 = q.y;
        const z2 = q.z;
    
        o.w=  w1 * w2 - x1 * x2 - y1 * y2 - z1 * z2;
        o.x=  w1 * x2 + x1 * w2 + y1 * z2 - z1 * y2;
        o.y=  w1 * y2 + y1 * w2 + z1 * x2 - x1 * z2;
        o.z=  w1 * z2 + z1 * w2 + x1 * y2 - y1 * x2;
    }

    rotate(x,y,z) {
        const q = new THREE.Quaternion(this.quaternion.x,this.quaternion.y,this.quaternion.z,this.quaternion.w).multiply(new THREE.Quaternion().setFromEuler(new THREE.Euler(x, y, z,"XYZ")));
        this.quaternion.x = q.x;
        this.quaternion.y = q.y;
        this.quaternion.z = q.z;
        this.quaternion.w = q.w;
    }
    
    multiply2(t, out) {
        const px = t.position.x;
        const py = t.position.y;
        const pz = t.position.z;

        out.position.x = this.position.x + (px * this.m3[0] + py * this.m3[3] + pz * this.m3[6] );
        out.position.y = this.position.y + (px * this.m3[1] + py * this.m3[4] + pz * this.m3[7] );
        out.position.z = this.position.z + (px * this.m3[2] + py * this.m3[5] + pz * this.m3[8] );
        this.mulquat(t.quaternion, out.quaternion);
        out.computeMatrix();
    }

    multiply(t, out) {
        const px = this.position.x + t.position.x;
        const py = this.position.y + t.position.y;
        const pz = this.position.z + t.position.z;

        out.position.x = px * this.m3[0] + py * this.m3[3] + pz * this.m3[6] ;
        out.position.y = px * this.m3[1] + py * this.m3[4] + pz * this.m3[7] ;
        out.position.z = px * this.m3[2] + py * this.m3[5] + pz * this.m3[8] ;
        this.mulquat(t.quaternion, out.quaternion);
        out.computeMatrix();
    }
    conjugate(o) { o.w = -this.quaternion.w; o.x = this.quaternion.x; o.y = this.quaternion.y; o.z = this.quaternion.z; }

    toBuffer3(out, ofs = 0) {
        out[ofs + 0] = this.m3[0];
        out[ofs + 1] = this.m3[1];
        out[ofs + 2] = this.m3[2];
        out[ofs + 3] = 0;

        out[ofs + 4] = this.m3[3];
        out[ofs + 5] = this.m3[4];
        out[ofs + 6] = this.m3[5];
        out[ofs + 7] = 0;

        out[ofs + 8] = this.m3[6];
        out[ofs + 9] = this.m3[7];
        out[ofs + 10] = this.m3[8];
        out[ofs + 11] = 0;
    }

    toBuffer4(out, ofs = 0) {
        out[ofs + 0] = this.m3[0];
        out[ofs + 1] = this.m3[1];
        out[ofs + 2] = this.m3[2];
        out[ofs + 3] = 0;

        out[ofs + 4] = this.m3[3];
        out[ofs + 5] = this.m3[4];
        out[ofs + 6] = this.m3[5];
        out[ofs + 7] = 0;

        out[ofs + 8] = this.m3[6];
        out[ofs + 9] = this.m3[7];
        out[ofs + 10] = this.m3[8];
        out[ofs + 11] = 0;

        out[ofs + 12] = this.position.x;
        out[ofs + 13] = this.position.y;
        out[ofs + 14] = this.position.z;
        out[ofs + 15] = 1.0;
    }
    toBuffer(out, ofs = 0)
    {
        this.toBuffer3(out, ofs);
        out[ofs + 12] = this.position.x;
        out[ofs + 13] = this.position.y;
        out[ofs + 14] = this.position.z;
        out[ofs + 15] = 1.0;
    }

    toBuffer3Packed(out, ofs = 0) {
        out[ofs + 0] = this.m3[0];
        out[ofs + 1] = this.m3[1];
        out[ofs + 2] = this.m3[2];

        out[ofs + 3] = this.m3[3];
        out[ofs + 4] = this.m3[4];
        out[ofs + 5] = this.m3[5];

        out[ofs + 6] = this.m3[6];
        out[ofs + 7] = this.m3[7];
        out[ofs + 8] = this.m3[8];
    }
    toBufferPacked(out, ofs = 0)
    {
        this.toBuffer3Packed(out, ofs);
        out[ofs + 9] = this.position.x;
        out[ofs + 10] = this.position.y;
        out[ofs + 11] = this.position.z;
    }

        fromMat4(mat){
        this.m3[0] = mat.elements[0];
        this.m3[1] = mat.elements[1];
        this.m3[2] = mat.elements[2];

        this.m3[3] = mat.elements[4];
        this.m3[4] = mat.elements[5];
        this.m3[5] = mat.elements[6];

        this.m3[6] = mat.elements[8];
        this.m3[7] = mat.elements[9];
        this.m3[8] = mat.elements[10];

        this.position.x = mat.elements[12];
        this.position.y = mat.elements[13];
        this.position.z = mat.elements[14];
    }

    
    getInverse(o) { 
        
        o.position.x = -this.position.x;
        o.position.y = -this.position.y;
        o.position.z = -this.position.z;
        this.conjugate(o.quaternion);
        o.computeMatrix();
    }

    getViewTransform(o) {
        this.conjugate(o.quaternion);
        o.computeMatrix();

        o.position.x = -(this.position.x * o.m3[0] + this.position.y * o.m3[3] + this.position.z * o.m3[6]) ;
        o.position.y = -(this.position.x * o.m3[1] + this.position.y * o.m3[4] + this.position.z * o.m3[7]) ;
        o.position.z = -(this.position.x * o.m3[2] + this.position.y * o.m3[5] + this.position.z * o.m3[8]) ;
    }
    

    getViewProj(proj, viewProj) {

        const tmp = new Transformation3();

        this.getViewTransform(tmp);

        const a00 = proj[0];
        const a01 = proj[1];
        const a02 = proj[2];
        const a03 = proj[3];
        const a10 = proj[4];
        const a11 = proj[5];
        const a12 = proj[6];
        const a13 = proj[7];
        const a20 = proj[8];
        const a21 = proj[9];
        const a22 = proj[10];
        const a23 = proj[11];
        const a30 = proj[12];
        const a31 = proj[13];
        const a32 = proj[14];
        const a33 = proj[15];

        const b00 = tmp.m3[0];
        const b01 = tmp.m3[1];
        const b02 = tmp.m3[2];
        const b03 = 0;
        const b10 = tmp.m3[3];
        const b11 = tmp.m3[4];
        const b12 = tmp.m3[5];
        const b13 = 0;
        const b20 = tmp.m3[6];
        const b21 = tmp.m3[7];
        const b22 = tmp.m3[8];
        const b23 = 0;
        const b30 = tmp.position.x;
        const b31 = tmp.position.y;
        const b32 = tmp.position.z;
        const b33 = 1;

        viewProj[0]  = b00 * a00 + b01 * a10 + b02 * a20 + b03 * a30;
        viewProj[1]  = b00 * a01 + b01 * a11 + b02 * a21 + b03 * a31;
        viewProj[2]  = b00 * a02 + b01 * a12 + b02 * a22 + b03 * a32;
        viewProj[3]  = b00 * a03 + b01 * a13 + b02 * a23 + b03 * a33;
        viewProj[4]  = b10 * a00 + b11 * a10 + b12 * a20 + b13 * a30;
        viewProj[5]  = b10 * a01 + b11 * a11 + b12 * a21 + b13 * a31;
        viewProj[6]  = b10 * a02 + b11 * a12 + b12 * a22 + b13 * a32;
        viewProj[7]  = b10 * a03 + b11 * a13 + b12 * a23 + b13 * a33;
        viewProj[8]  = b20 * a00 + b21 * a10 + b22 * a20 + b23 * a30;
        viewProj[9]  = b20 * a01 + b21 * a11 + b22 * a21 + b23 * a31;
        viewProj[10] = b20 * a02 + b21 * a12 + b22 * a22 + b23 * a32;
        viewProj[11] = b20 * a03 + b21 * a13 + b22 * a23 + b23 * a33;
        viewProj[12] = b30 * a00 + b31 * a10 + b32 * a20 + b33 * a30;
        viewProj[13] = b30 * a01 + b31 * a11 + b32 * a21 + b33 * a31;
        viewProj[14] = b30 * a02 + b31 * a12 + b32 * a22 + b33 * a32;
        viewProj[15] = b30 * a03 + b31 * a13 + b32 * a23 + b33 * a33;
    }

    /* lookat cemetary

    lookAt(destPoint, order = 0) {

        const forward = new THREE.Vector3(destPoint.x - this.position.x , destPoint.y - this.position.y  , destPoint.z - this.position.z ) ;
        forward.normalize();

        if(order !== 0)
            forward.negate();
        
        //OrthoNormalize(&forward, &up);

        const right = upVec.clone().cross(forward);
    
        //Quaternion ret;
        this.quaternion.w = Math.sqrt(1.0 + right.x + upVec.y + forward.z) * 0.5;
        const w4_recip = 1.0 / (4.0 * this.quaternion.w);
        this.quaternion.x = (upVec.z - forward.y) * w4_recip;
        this.quaternion.y = (forward.x - right.z) * w4_recip;
        this.quaternion.z = ( right.y - upVec.x) * w4_recip;
        this.computeMatrix();
    }
    lookAt(destPoint)
    {
        const toVector = new THREE.Vector3(this.position.x - destPoint.x, this.position.y - destPoint.y, this.position.z -destPoint.z ) ;
        toVector.normalize();

        //compute rotation axis
        let rotAxis = upVec.clone().cross(toVector);
        rotAxis.normalize();

        //find the angle around rotation axis
        const dot = frontVec.dot(toVector);
        const ang = Math.acos(dot);
        const s = Math.sin(ang / 2);
                
       //convert axis angle to quaternion

        this.quaternion.w = Math.cos(ang / 2)
        this.quaternion.x = rotAxis.x * s;
        this.quaternion.y = rotAxis.y * s;
        this.quaternion.z = rotAxis.z * s;

        this.computeMatrix();
    }
    */

   computeQuaternion() {
        const m00 = this.m3[0];
        const m01 = this.m3[3];
        const m02 = this.m3[6];

        const m10 = this.m3[1];
        const m11 = this.m3[4];
        const m12 = this.m3[7];

        const m20 = this.m3[2];
        const m21 = this.m3[5];
        const m22 = this.m3[8];

        const tr =  m00 + m11 + m22;

        if (tr > 0) { 
            const S = Math.sqrt(tr+1.0) * 2; // S=4*qw 
            this.quaternion.w = 0.25 * S;
            this.quaternion.x = (m21 - m12) / S;
            this.quaternion.y = (m02 - m20) / S; 
            this.quaternion.z = (m10 - m01) / S; 
        } else if ((m00 > m11)&(m00 > m22)) { 
            const S = Math.sqrt(1.0 + m00 - m11 - m22) * 2; // S=4*qx 
            this.quaternion.w = (m21 - m12) / S;
            this.quaternion.x = 0.25 * S;
            this.quaternion.y = (m01 + m10) / S; 
            this.quaternion.z = (m02 + m20) / S; 
        } else if (m11 > m22) { 
            const S = Math.sqrt(1.0 + m11 - m00 - m22) * 2; // S=4*qy
            this.quaternion.w = (m02 - m20) / S;
            this.quaternion.x = (m01 + m10) / S; 
            this.quaternion.y = 0.25 * S;
            this.quaternion.z = (m12 + m21) / S; 
        } else { 
            const S = Math.sqrt(1.0 + m22 - m00 - m11) * 2; // S=4*qz
            this.quaternion.w = (m10 - m01) / S;
            this.quaternion.x = (m02 + m20) / S;
            this.quaternion.y = (m12 + m21) / S;
            this.quaternion.z = 0.25 * S;
        }
   }

    lookAt(destPoint, upDir = null) {

        const forward = new THREE.Vector3(this.position.x - destPoint.x, this.position.y - destPoint.y, this.position.z - destPoint.z);
        if ( forward.lengthSq() === 0 ) {
			forward.z = 1;
		}
        forward.normalize();

        if(!upDir) 
        {
            upDir = new THREE.Vector3(0, 1, 0 );
            forward.negate();
        }

        const right = new THREE.Vector3().crossVectors(upDir, forward);
		if ( right.lengthSq() === 0 ) {
			// up and z are parallel
			if ( Math.abs( upDir.z ) === 1 ) 
				forward.x += 0.0001;
			 else 
				forward.z += 0.0001;

            forward.normalize();
			right.crossVectors( upDir, forward );
		}
        right.normalize();

        const up = new THREE.Vector3().crossVectors(forward, right);
        up.normalize();

        this.m3[0] = right.x;
        this.m3[1] = right.y;
        this.m3[2] = right.z;
        this.m3[3] = up.x;
        this.m3[4] = up.y;
        this.m3[5] = up.z;
        this.m3[6] = forward.x;
        this.m3[7] = forward.y;
        this.m3[8] = forward.z;
        this.computeQuaternion();
    }


    computeMatrix() {

        const x = this.quaternion.x, y = this.quaternion.y, z = this.quaternion.z, w = this.quaternion.w;
		const x2 = x + x,	y2 = y + y, z2 = z + z;
		const xx = x * x2, xy = x * y2, xz = x * z2;
		const yy = y * y2, yz = y * z2, zz = z * z2;
		const wx = w * x2, wy = w * y2, wz = w * z2;
        
		this.m3[ 0 ] = ( 1 - ( yy + zz ) ) ;
		this.m3[ 1 ] = ( xy + wz ) ;
		this.m3[ 2 ] = ( xz - wy ) ;

		this.m3[ 3 ] = ( xy - wz ) ;
		this.m3[ 4 ] = ( 1 - ( xx + zz ) );
		this.m3[ 5 ] = ( yz + wx ) ;
		
		this.m3[ 6 ] = ( xz + wy ) ;
		this.m3[ 7 ] = ( yz - wx ) ;
		this.m3[ 8 ] = ( 1 - ( xx + yy ) );


        /*
        const sqw = this.quaternion.w * this.quaternion.w;
        const sqx = this.quaternion.x * this.quaternion.x;
        const sqy = this.quaternion.y * this.quaternion.y;
        const sqz = this.quaternion.z * this.quaternion.z;

        // invs (inverse square length) is only required if quaternion is not already normalised
        const invs = 1 / (sqx + sqy + sqz + sqw)
        this.m3[0 * 3 + 0] = (sqx - sqy - sqz + sqw) * invs; // since sqw + sqx + sqy + sqz =1/invs*invs
        this.m3[1 * 3 + 1] = (-sqx + sqy - sqz + sqw) * invs;
        this.m3[2 * 3 + 2] = (-sqx - sqy + sqz + sqw) * invs;

        let tmp1 = this.quaternion.x * this.quaternion.y;
        let tmp2 = this.quaternion.z * this.quaternion.w;
        this.m3[0 * 3 + 1] = 2.0 * (tmp1 + tmp2) * invs;
        this.m3[1 * 3 + 0] = 2.0 * (tmp1 - tmp2) * invs;

        tmp1 = this.quaternion.x * this.quaternion.z;
        tmp2 = this.quaternion.y * this.quaternion.w;
        this.m3[0 * 3 + 2] = 2.0 * (tmp1 - tmp2) * invs;
        this.m3[2 * 3 + 0] = 2.0 * (tmp1 + tmp2) * invs;
        tmp1 = this.quaternion.y * this.quaternion.z;
        tmp2 = this.quaternion.x * this.quaternion.w;
        this.m3[1 * 3 + 2] = 2.0 * (tmp1 + tmp2) * invs;
        this.m3[2 * 3 + 1] = 2.0 * (tmp1 - tmp2) * invs;
        */
    }

    applyV(v) {
        const px = v.x;
        const py = v.y;
        const pz = v.z;

        return {x: this.position.x + (px * this.m3[0] + py * this.m3[3] + pz * this.m3[6]),
                y: this.position.y + (px * this.m3[1] + py * this.m3[4] + pz * this.m3[7]),
                z: this.position.z + (px * this.m3[2] + py * this.m3[5] + pz * this.m3[8])}
    }

    applyQV(v) {
        return {x: v.x * this.m3[0] + v.y * this.m3[3] + v.z * this.m3[6],
                y: v.x * this.m3[1] + v.y * this.m3[4] + v.z * this.m3[7],
                z: v.x * this.m3[2] + v.y * this.m3[5] + v.z * this.m3[8]}
    }
    apply(g) {
        for (let v = 0; v < g.attributes.position.array.length; v += 3) {
            const x = g.attributes.position.array[v + 0];
            const y = g.attributes.position.array[v + 1];
            const z = g.attributes.position.array[v + 2];
            
            g.attributes.position.array[v + 0] = x * this.m3[0] + y * this.m3[3] + z * this.m3[6] + this.position.x;
            g.attributes.position.array[v + 1] = x * this.m3[1] + y * this.m3[4] + z * this.m3[7] + this.position.y;
            g.attributes.position.array[v + 2] = x * this.m3[2] + y * this.m3[5] + z * this.m3[8] + this.position.z;
        }
    }

    applyQ(g) {
        for (let v = 0; v < g.attributes.position.array.length; v += 3) {
            const x = g.attributes.position.array[v + 0];
            const y = g.attributes.position.array[v + 1];
            const z = g.attributes.position.array[v + 2];

            g.attributes.position.array[v + 0] = x * this.m3[0] + y * this.m3[3] + z * this.m3[6];
            g.attributes.position.array[v + 1] = x * this.m3[1] + y * this.m3[4] + z * this.m3[7];
            g.attributes.position.array[v + 2] = x * this.m3[2] + y * this.m3[5] + z * this.m3[8];
        }
    }
}

export class TransformationLerp{

    nElements;
    array;
    time;
    deltaTime;


    constructor(num, buffer, ofs, time){
        this.nElements = num;
        this.time = time;
        this.deltaTime = 0;
        this.active = new Array(this.nElements);

        this.mq = new THREE.Quaternion();
        this.dq= new THREE.Quaternion();
        this.qf = new THREE.Quaternion();
        this.q= new THREE.Quaternion();


        this.array = new Float32Array(this.nElements * 16);
        this.cnt = 0;

        
        for(let n=0;n<this.nElements;n++){

            let curEl = n * 16; // 16 alignment

            this.array[curEl++] = buffer[ofs++]; // id

            this.array[curEl++] = 0.0; // delta px
            this.array[curEl++] = 0.0; // delta py
            this.array[curEl++] = 0.0; // delta pz

            this.array[curEl++] = 0.0; // delta qx
            this.array[curEl++] = 0.0; // delta qy
            this.array[curEl++] = 0.0; // delta qz
            this.array[curEl++] = 1.0; // delta qw
            if(buffer !== null){
                this.array[curEl++] = buffer[ofs++]; // px
                this.array[curEl++] = buffer[ofs++]; // py
                this.array[curEl++] = buffer[ofs++]; // pz
    
                this.array[curEl++] = buffer[ofs++]; // qx
                this.array[curEl++] = buffer[ofs++]; // qy
                this.array[curEl++] = buffer[ofs++]; // qz
                this.array[curEl++] = buffer[ofs++]; // qw
            }else{
                this.array[curEl++] = 0.0; // delta px
                this.array[curEl++] = 0.0; // delta py
                this.array[curEl++] = 0.0; // delta pz
    
                this.array[curEl++] = 0.0; // delta qx
                this.array[curEl++] = 0.0; // delta qy
                this.array[curEl++] = 0.0; // delta qz
                this.array[curEl++] = 1.0; // delta qw
            }
                
            
        }
        
    }

    computeDelta(buffer, ofs, bufElements, time, mode = 0, log = false){

        if(time<=this.time){
            this.time = time;
            return ofs + bufElements * 8;
        }
            

        this.deltaTime = time - this.time;
        this.time = time;

        for(let n = 0;n<this.nElements;n++)
        {
            this.active[n] = false;
        }
        
        for(let nb = 0; nb<bufElements; nb++){

            const iid = parseInt(buffer[ofs++]);
            const id = (mode === 0) ? iid : nb;
            const curEl = id * 16;
            this.active[id] = true;

            const nx = buffer[ofs++];
            const ny = buffer[ofs++];
            const nz = buffer[ofs++];

            const nqx = buffer[ofs++];
            const nqy = buffer[ofs++];
            const nqz = buffer[ofs++];
            const nqw = buffer[ofs++];

            const qx = -this.array[curEl + 11]; // current quaternion x
            const qy = -this.array[curEl + 12]; // current quaternion y
            const qz = -this.array[curEl + 13]; // current quaternion z
            const qw = this.array[curEl + 14]; // current quaternion w
            

            this.array[curEl + 4] = qx * nqw  + qw * nqx + qy * nqz - qz * nqy; // delta qy
            this.array[curEl + 5] = qy * nqw  + qw * nqy + qz * nqx - qx * nqz; // delta qz
            this.array[curEl + 6] = qz * nqw  + qw * nqz + qx * nqy - qy * nqx; // delta qw
            this.array[curEl + 7] = qw * nqw  - qx * nqx - qy * nqy - qz * nqz; // delta qx

            const x  = this.array[curEl + 8]; // current position x
            const y  = this.array[curEl + 9]; // current position y
            const z  = this.array[curEl + 10]; // current position z

            this.array[curEl + 1] = nx - x; // delta px
            this.array[curEl + 2] = ny - y; // delta py
            this.array[curEl + 3] = nz - z; // delta pz
       
            if((log === true)&&(nb === 0)){
                console.log('TransformationLerp :: compute delta p : '+x.toFixed(2)+','+y.toFixed(2)+','+z.toFixed(2)+' '+nx.toFixed(2)+','+ny.toFixed(2)+','+nz.toFixed(2));
                console.log('TransformationLerp :: compute delta dp : '+this.array[curEl + 1] .toFixed(2)+','+this.array[curEl + 2] .toFixed(2)+','+this.array[curEl + 3] .toFixed(2));
            
                console.log('TransformationLerp :: compute delta q : -'+(-qx.toFixed(2))+','+(-qy.toFixed(2))+','+(-qz.toFixed(2))+','+qw.toFixed(2)+' '+nqx.toFixed(2)+','+nqy.toFixed(2)+','+nqz.toFixed(2)+','+nqw.toFixed(2));
                console.log('TransformationLerp :: compute delta dq : '+this.array[curEl + 4] .toFixed(2)+','+this.array[curEl + 5] .toFixed(2)+','+this.array[curEl + 6] .toFixed(2)+','+this.array[curEl + 7] .toFixed(2));
            }
  
 
            this.array[curEl + 8] = nx; // new position x
            this.array[curEl + 9] = ny; // new position y
            this.array[curEl + 10] = nz; // new quaternion z

            this.array[curEl + 11] = nqx; // new quaternion x
            this.array[curEl + 12] = nqy; // new quaternion y
            this.array[curEl + 13] = nqz; // new quaternion z
            this.array[curEl + 14] = nqw; // new quaternion w
        }

        return ofs;
    }

    getInterpolatedValue(n, time , t, log = false){

        const curEl = n * 16;

        const px = this.array[curEl + 8];
        const py = this.array[curEl + 9];
        const pz = this.array[curEl + 10];

        const qx = this.array[curEl + 11];
        const qy = this.array[curEl + 12];
        const qz = this.array[curEl + 13];
        const qw = this.array[curEl + 14];

        if(!this.active[n]){
            t.position.x = px;
            t.position.y = py;
            t.position.z = pz;

            t.quaternion.x = qx;
            t.quaternion.y = qy; // delta qy
            t.quaternion.z = qz; // delta qz
            t.quaternion.w = qw; // delta qw
            return false;
        }

        if((this.deltaTime<=0)||(time <= this.time))
        {

            t.position.x = px;
            t.position.y = py;
            t.position.z = pz;

            t.quaternion.x = qx;
            t.quaternion.y = qy; // delta qy
            t.quaternion.z = qz; // delta qz
            t.quaternion.w = qw; // delta qw
            return true;
        }
        
        const dx = this.array[curEl + 1];
        const dy = this.array[curEl + 2];
        const dz = this.array[curEl + 3];

        const dqx = this.array[curEl + 4];
        const dqy = this.array[curEl + 5];
        const dqz = this.array[curEl + 6];
        const dqw = this.array[curEl + 7];

        const dt = time - this.time;
        const fac = dt / this.deltaTime;
 
        if(fac > 1) {

            t.position.x = px + dx;
            t.position.y = py + dy;
            t.position.z = pz + dz;
            
            /*
            t.quaternion.x = dqw * qw - dqx * qx - dqy * qy - dqz * qz; // delta qx
            t.quaternion.y = dqw * qx + dqx * qw + dqy * qz - dqz * qy; // delta qy
            t.quaternion.z = dqw * qy + dqy * qw + dqz * qx - dqx * qz; // delta qz
            t.quaternion.w = dqw * qz + dqz * qw + dqx * qy - dqy * qx; // delta qw
            */

            t.quaternion.x = qx * dqw  + qw * dqx + qy * dqz - qz * dqy; // delta qy
            t.quaternion.y = qy * dqw  + qw * dqy + qz * dqx - qx * dqz; // delta qz
            t.quaternion.z = qz * dqw  + qw * dqz + qx * dqy - qy * dqx; // delta qw
            t.quaternion.w = qw * dqw  - qx * dqx - qy * dqy - qz * dqz; // delta qx

            return true;
        }

        t.position.x = px + dx * fac;
        t.position.y = py + dy * fac;
        t.position.z = pz + dz * fac;

        
        /*
        const mq = new THREE.Quaternion(qx, qy, qz, qw);
        const qf= mq.clone().multiply(new THREE.Quaternion(dqx, dqy, dqz, dqw));
        const q= new THREE.Quaternion().slerpQuaternions(mq, qf, fac);
        */

        t.quaternion.set(this.q.x,this.q.y, this.q.z, this.q.w); // delta qw

        this.mq.set(qx, qy, qz, qw);
        this.dq.set(dqx, dqy, dqz, dqw)

        //const mq = new THREE.Quaternion(qx, qy, qz, qw);
        this.qf.multiplyQuaternions(this.mq, this.dq);
        this.q.slerpQuaternions(this.mq, this.qf, fac );
        
        //const sq = new THREE.Quaternion().slerp(new THREE.Quaternion(dqx, dqy, dqz, dqw), fac);
        //const q = sq.multiply(new THREE.Quaternion(qx, qy, qz, qw));    

        t.quaternion.x = this.q.x; // delta qx
        t.quaternion.y = this.q.y; // delta qy
        t.quaternion.z = this.q.z; // delta qz
        t.quaternion.w = this.q.w; // delta qw

        if((log === true)&&(n === 0)){

            const dt = time - this.time;
            const fac = dt / this.deltaTime;

            console.log('compute interp '+time.toFixed(2)+' '+this.time.toFixed(2)+' '+dt.toFixed(2)+' '+fac.toFixed(2));
            console.log('compute interp p : '+px.toFixed(2)+','+py.toFixed(2)+','+pz.toFixed(2)+' '+dx.toFixed(2)+','+dy.toFixed(2)+','+dz.toFixed(2));
            console.log('compute interp np : '+t.position.x.toFixed(2)+','+t.position.y .toFixed(2)+','+t.position.z.toFixed(2));
        
            console.log('compute interp qq : '+(qx.toFixed(2))+','+(qy.toFixed(2))+','+(qz.toFixed(2))+','+qw.toFixed(2)+' '+dqx.toFixed(2)+','+dqy.toFixed(2)+','+dqz.toFixed(2)+','+dqw.toFixed(2));
            console.log('compute interp nq : '+t.quaternion.x .toFixed(2)+','+t.quaternion.y.toFixed(2)+','+t.quaternion.z.toFixed(2)+','+t.quaternion.w.toFixed(2));
        }

        return true;
    }
}


export class TransformationLerpRaw{

    nElements;
    array;
    time;
    deltaTime;


    constructor(num, buffer, ofs, time, stride = 7){
        this.nElements = num;
        this.time = time;
        this.deltaTime = 0;

        this.mq = new THREE.Quaternion();
        this.dq= new THREE.Quaternion();
        this.qf = new THREE.Quaternion();
        this.q= new THREE.Quaternion();

        this.array = new Float32Array(this.nElements * 16);
       
        
        for(let curEl = 0;curEl<this.nElements * 16; curEl += 16, ofs += stride){

            this.array[curEl++] = 0.0; // align on 8
            this.array[curEl++] = 0.0; // delta px
            this.array[curEl++] = 0.0; // delta py
            this.array[curEl++] = 0.0; // delta pz

            this.array[curEl++] = 0.0; // delta qx
            this.array[curEl++] = 0.0; // delta qy
            this.array[curEl++] = 0.0; // delta qz
            this.array[curEl++] = 1.0; // delta qw

            this.array[curEl++] = buffer[ofs + 0]; // px
            this.array[curEl++] = buffer[ofs + 1]; // py
            this.array[curEl++] = buffer[ofs + 2]; // pz

            this.array[curEl++] = buffer[ofs + 3]; // qx
            this.array[curEl++] = buffer[ofs + 4]; // qy
            this.array[curEl++] = buffer[ofs + 5]; // qz
            this.array[curEl++] = buffer[ofs + 6]; // qw
        }
        
    }

    computeDelta(buffer, ofs, stride, time, log = false){

        if(time<=this.time){
            this.time = time;
            return ofs + this.nElements * stride;
        }
            

        this.deltaTime = time - this.time;
        this.time = time;
        
        for(let nb = 0; nb< this.nElements; nb++){

            const curEl = nb * 16;

            const nx = buffer[ofs + 0];
            const ny = buffer[ofs + 1];
            const nz = buffer[ofs + 2];

            const nqx = buffer[ofs + 3];
            const nqy = buffer[ofs + 4];
            const nqz = buffer[ofs + 5];
            const nqw = buffer[ofs + 6];
           
            const x  = this.array[curEl + 8]; // current position x
            const y  = this.array[curEl + 9]; // current position y
            const z  = this.array[curEl + 10]; // current position z

            const qx = -this.array[curEl + 11]; // current quaternion x
            const qy = -this.array[curEl + 12]; // current quaternion y
            const qz = -this.array[curEl + 13]; // current quaternion z
            const qw = this.array[curEl + 14]; // current quaternion w

            this.array[curEl + 1] = nx - x; // delta px
            this.array[curEl + 2] = ny - y; // delta py
            this.array[curEl + 3] = nz - z; // delta pz
     
            this.array[curEl + 4] = qx * nqw  + qw * nqx + qy * nqz - qz * nqy; // delta qy
            this.array[curEl + 5] = qy * nqw  + qw * nqy + qz * nqx - qx * nqz; // delta qz
            this.array[curEl + 6] = qz * nqw  + qw * nqz + qx * nqy - qy * nqx; // delta qw
            this.array[curEl + 7] = qw * nqw  - qx * nqx - qy * nqy - qz * nqz; // delta qx
            

            if((log === true)&&(nb === 3)){
                console.log('TransformationLerpRaw :: compute delta p : '+x.toFixed(2)+','+y.toFixed(2)+','+z.toFixed(2)+' '+nx.toFixed(2)+','+ny.toFixed(2)+','+nz.toFixed(2));
                console.log('TransformationLerpRaw :: compute delta dp : '+this.array[curEl + 1] .toFixed(2)+','+this.array[curEl + 2] .toFixed(2)+','+this.array[curEl + 3] .toFixed(2));
            
                console.log('TransformationLerpRaw :: compute delta q : -'+(-qx.toFixed(2))+','+(-qy.toFixed(2))+','+(-qz.toFixed(2))+','+qw.toFixed(2)+' '+nqx.toFixed(2)+','+nqy.toFixed(2)+','+nqz.toFixed(2)+','+nqw.toFixed(2));
                console.log('TransformationLerpRaw :: compute delta dq : '+this.array[curEl + 4] .toFixed(2)+','+this.array[curEl + 5] .toFixed(2)+','+this.array[curEl + 6] .toFixed(2)+','+this.array[curEl + 7] .toFixed(2));
            }
   
            this.array[curEl + 8] = nx; // new position x
            this.array[curEl + 9] = ny; // new position y
            this.array[curEl + 10] = nz; // new quaternion z

            this.array[curEl + 11] = nqx; // new quaternion x
            this.array[curEl + 12] = nqy; // new quaternion y
            this.array[curEl + 13] = nqz; // new quaternion z
            this.array[curEl + 14] = nqw; // new quaternion w

            ofs += stride;
        }

        return ofs;
    }

    getInterpolatedValue(n, time , t, log = false){

        const curEl = n * 16;

        const dx = this.array[curEl + 1];
        const dy = this.array[curEl + 2];
        const dz = this.array[curEl + 3];

        const dqx = this.array[curEl + 4];
        const dqy = this.array[curEl + 5];
        const dqz = this.array[curEl + 6];
        const dqw = this.array[curEl + 7];

        const px = this.array[curEl + 8];
        const py = this.array[curEl + 9];
        const pz = this.array[curEl + 10];

        const qx = this.array[curEl + 11];
        const qy = this.array[curEl + 12];
        const qz = this.array[curEl + 13];
        const qw = this.array[curEl + 14];

        //if((this.deltaTime<=0)||(time <= this.time))
        {

            t.position.x = px;
            t.position.y = py;
            t.position.z = pz;

            t.quaternion.x = qx;
            t.quaternion.y = qy; // delta qy
            t.quaternion.z = qz; // delta qz
            t.quaternion.w = qw; // delta qw
            return true;
        }

        const dt = time - this.time;
        const fac = dt / this.deltaTime;
 
        if(fac >= 1) {

            t.position.x = px + dx;
            t.position.y = py + dy;
            t.position.z = pz + dz;
            
            /*
            t.quaternion.x = dqw * qw - dqx * qx - dqy * qy - dqz * qz; // delta qx
            t.quaternion.y = dqw * qx + dqx * qw + dqy * qz - dqz * qy; // delta qy
            t.quaternion.z = dqw * qy + dqy * qw + dqz * qx - dqx * qz; // delta qz
            t.quaternion.w = dqw * qz + dqz * qw + dqx * qy - dqy * qx; // delta qw
            */

            t.quaternion.x = qx * dqw  + qw * dqx + qy * dqz - qz * dqy; // delta qy
            t.quaternion.y = qy * dqw  + qw * dqy + qz * dqx - qx * dqz; // delta qz
            t.quaternion.z = qz * dqw  + qw * dqz + qx * dqy - qy * dqx; // delta qw
            t.quaternion.w = qw * dqw  - qx * dqx - qy * dqy - qz * dqz; // delta qx

            return true;
        }

        t.position.x = px + dx * fac;
        t.position.y = py + dy * fac;
        t.position.z = pz + dz * fac;

        this.mq.set(qx, qy, qz, qw);
        this.dq.set(dqx, dqy, dqz, dqw)
        this.qf.multiplyQuaternions(this.mq, this.dq);
        this.q.slerpQuaternions(this.mq, this.qf, fac);

        
        //const sq = new THREE.Quaternion().slerp(new THREE.Quaternion(dqx, dqy, dqz, dqw), fac);
        //const q = sq.multiply(new THREE.Quaternion(qx, qy, qz, qw));    

        t.quaternion.x = this.q.x; // delta qx
        t.quaternion.y = this.q.y; // delta qy
        t.quaternion.z = this.q.z; // delta qz
        t.quaternion.w = this.q.w; // delta qw

        if((log === true)&&(n === 3)){

            const dt = time - this.time;
            const fac = dt / this.deltaTime;

            console.log('compute interp '+time.toFixed(2)+' '+this.time.toFixed(2)+' '+dt.toFixed(2)+' '+fac.toFixed(2));
            console.log('compute interp p : '+px.toFixed(2)+','+py.toFixed(2)+','+pz.toFixed(2)+' '+dx.toFixed(2)+','+dy.toFixed(2)+','+dz.toFixed(2));
            console.log('compute interp np : '+t.position.x.toFixed(2)+','+t.position.y .toFixed(2)+','+t.position.z.toFixed(2));
        
            console.log('compute interp q : '+(qx.toFixed(2))+','+(qy.toFixed(2))+','+(qz.toFixed(2))+','+qw.toFixed(2)+' '+dqx.toFixed(2)+','+dqy.toFixed(2)+','+dqz.toFixed(2)+','+dqw.toFixed(2));
            console.log('compute interp dq : '+t.quaternion.x .toFixed(2)+','+t.quaternion.y.toFixed(2)+','+t.quaternion.z.toFixed(2)+','+t.quaternion.w.toFixed(2));
        }

        return true;
    }
}

export class QuaternionLerp{

    nElements;
    array;
    time;
    deltaTime;


    constructor(num, buffer, ofs, time){
        this.nElements = num;
        this.time = time;
        this.deltaTime = 0;
        this.active = new Array(this.nElements);

        this.mq = new THREE.Quaternion();
        this.dq= new THREE.Quaternion();
        this.qf = new THREE.Quaternion();
        this.q= new THREE.Quaternion();


        this.array = new Float32Array(this.nElements * 9);
        this.cnt = 0;
        
        for(let n=0;n<this.nElements;n++){

            let curEl = n * 9; // 16 alignment

            this.array[curEl++] = buffer[ofs++]; // id

            this.array[curEl++] = 0.0; // delta qx
            this.array[curEl++] = 0.0; // delta qy
            this.array[curEl++] = 0.0; // delta qz
            this.array[curEl++] = 1.0; // delta qw

            this.array[curEl++] = buffer[ofs++]; // qx
            this.array[curEl++] = buffer[ofs++]; // qy
            this.array[curEl++] = buffer[ofs++]; // qz
            this.array[curEl++] = buffer[ofs++]; // qw
        }
        
    }

    computeDelta(buffer, ofs, bufElements, time, log = false){

        if(time<=this.time){
            this.time = time;
            return ofs + bufElements * 5;
        }


        this.deltaTime = time - this.time;
        this.time = time;

        for(let n = 0;n<this.nElements;n++)
        {
            this.active[n] = false;
        }
        
        for(let nb = 0; nb<bufElements; nb++){

            const id = parseInt(buffer[ofs++]);
            const curEl = id * 9;

            this.active[id] = true;

            const nqx = buffer[ofs++];
            const nqy = buffer[ofs++];
            const nqz = buffer[ofs++];
            const nqw = buffer[ofs++];
           
            const qx = -this.array[curEl + 5]; // current quaternion x
            const qy = -this.array[curEl + 6]; // current quaternion y
            const qz = -this.array[curEl + 7]; // current quaternion z
            const qw = this.array[curEl + 8]; // current quaternion w

            this.array[curEl + 1] = qx * nqw  + qw * nqx + qy * nqz - qz * nqy; // delta qy
            this.array[curEl + 2] = qy * nqw  + qw * nqy + qz * nqx - qx * nqz; // delta qz
            this.array[curEl + 3] = qz * nqw  + qw * nqz + qx * nqy - qy * nqx; // delta qw
            this.array[curEl + 4] = qw * nqw  - qx * nqx - qy * nqy - qz * nqz; // delta qx
            

            if((log === true)&&(nb === 3)){
                console.log('q compute delta q : -'+(-qx.toFixed(2))+','+(-qy.toFixed(2))+','+(-qz.toFixed(2))+','+qw.toFixed(2)+' '+nqx.toFixed(2)+','+nqy.toFixed(2)+','+nqz.toFixed(2)+','+nqw.toFixed(2));
                console.log('q compute delta dq : '+this.array[curEl + 1] .toFixed(2)+','+this.array[curEl + 2] .toFixed(2)+','+this.array[curEl + 3] .toFixed(2)+','+this.array[curEl + 4] .toFixed(2));
            }
  
            this.array[curEl + 5] = nqx; // new quaternion x
            this.array[curEl + 6] = nqy; // new quaternion y
            this.array[curEl + 7] = nqz; // new quaternion z
            this.array[curEl + 8] = nqw; // new quaternion w
        }

        return ofs;
    }

    getInterpolatedValue(n, time , t, log = false){

        const curEl = n * 9;


        const qx = this.array[curEl + 5];
        const qy = this.array[curEl + 6];
        const qz = this.array[curEl + 7];
        const qw = this.array[curEl + 8];

        t.quaternion.x = qx;
        t.quaternion.y = qy; // delta qy
        t.quaternion.z = qz; // delta qz
        t.quaternion.w = qw; // delta qw
        return true;

        if(!this.active[n]){
            t.quaternion.x = qx;
            t.quaternion.y = qy; // delta qy
            t.quaternion.z = qz; // delta qz
            t.quaternion.w = qw; // delta qw
            return false;
        }
        const dqx = this.array[curEl + 1];
        const dqy = this.array[curEl + 2];
        const dqz = this.array[curEl + 3];
        const dqw = this.array[curEl + 4];

        if((this.deltaTime<=0)||(time <= this.time)){

            t.quaternion.x = qx;
            t.quaternion.y = qy; // delta qy
            t.quaternion.z = qz; // delta qz
            t.quaternion.w = qw; // delta qw
            return true;
        }

        const dt = time - this.time;
        const fac = dt / this.deltaTime;
 
        if(fac > 1) {

            t.quaternion.x = qx * dqw  + qw * dqx + qy * dqz - qz * dqy; // delta qy
            t.quaternion.y = qy * dqw  + qw * dqy + qz * dqx - qx * dqz; // delta qz
            t.quaternion.z = qz * dqw  + qw * dqz + qx * dqy - qy * dqx; // delta qw
            t.quaternion.w = qw * dqw  - qx * dqx - qy * dqy - qz * dqz; // delta qx

            return true;
        }

        this.mq.set(qx, qy, qz, qw);
        this.dq.set(dqx, dqy, dqz, dqw);
        this.qf.multiplyQuaternions(this.mq , this.dq);
        this.q.slerpQuaternions(this.mq, this.qf, fac);
        /*
        const mq = new THREE.Quaternion(qx, qy, qz, qw);
        const qf= mq.clone().multiply(new THREE.Quaternion(dqx, dqy, dqz, dqw));
        const q= new THREE.Quaternion().slerpQuaternions(mq, qf, fac);
        */

        t.quaternion.x = this.q.x; // delta qx
        t.quaternion.y = this.q.y; // delta qy
        t.quaternion.z = this.q.z; // delta qz
        t.quaternion.w = this.q.w; // delta qw

        if((log === true)&&(n === 3)){

            const dt = time - this.time;
            const fac = dt / this.deltaTime;

            console.log('qcompute interp '+time.toFixed(2)+' '+this.time.toFixed(2)+' '+dt.toFixed(2)+' '+fac.toFixed(2));
        
            console.log('qcompute interp q : '+(qx.toFixed(2))+','+(qy.toFixed(2))+','+(qz.toFixed(2))+','+qw.toFixed(2)+' '+dqx.toFixed(2)+','+dqy.toFixed(2)+','+dqz.toFixed(2)+','+dqw.toFixed(2));
            console.log('qcompute interp dq : '+t.quaternion.x .toFixed(2)+','+t.quaternion.y.toFixed(2)+','+t.quaternion.z.toFixed(2)+','+t.quaternion.w.toFixed(2));
        }

        return true;
    }
}
export class BoneLerp{

    nElements;
    array;
    time;
    deltaTime;


    constructor(num, buffer, ofs, time){
        this.nElements = num;
        this.time = time;
        this.deltaTime = 0;
        this.active = new Array(this.nElements);

        this.mq = new THREE.Quaternion();
        this.dq= new THREE.Quaternion();
        this.qf = new THREE.Quaternion();
        this.q= new THREE.Quaternion();

        this.array = new Float32Array(this.nElements * 16);
        this.cnt = 0;
        let curEl = 0; // 16 alignment
        
        for(let n=0;n<this.nElements;n++){

            const id = buffer[ofs++]; // id
            

            this.array[curEl++] = id;
            this.array[curEl++] = 0.0; // delta qx
            this.array[curEl++] = 0.0; // delta qy
            this.array[curEl++] = 0.0; // delta qz
            this.array[curEl++] = 1.0; // delta qw

            this.array[curEl++] = buffer[ofs++]; // qx
            this.array[curEl++] = buffer[ofs++]; // qy
            this.array[curEl++] = buffer[ofs++]; // qz
            this.array[curEl++] = buffer[ofs++]; // qw

            const life =  buffer[ofs++]; // qw
            this.array[curEl++] = life; // qw

            if(life == 0) {
                this.array[curEl++] = 0; // qy
                this.array[curEl++] = 0; // qz
                this.array[curEl++] = 0; // qw
                
                this.array[curEl++] = buffer[ofs++]; // qy
                this.array[curEl++] = buffer[ofs++]; // qz
                this.array[curEl++] = buffer[ofs++]; // qw
            }else 
                curEl += 6
        }
        
    }

    computeDelta(buffer, ofs, bufElements, time, log = false){

        if(time<=this.time){

            for(let n = 0;n<bufElements;n++) {
            
                ofs += 5;
                const life = buffer[ofs++];
                if(life === 0)
                    ofs += 3;
            }
            this.time = time;
            return ofs;
        }
            

        this.deltaTime = time - this.time;
        this.time = time;
        
        for(let nb = 0; nb<bufElements; nb++){

            const id = parseInt(buffer[ofs++]);
            const curEl = id * 16;

            this.active[id] = true;

            const nqx = buffer[ofs++];
            const nqy = buffer[ofs++];
            const nqz = buffer[ofs++];
            const nqw = buffer[ofs++];

            const life = buffer[ofs++];
           
            const qx = -this.array[curEl + 5]; // current quaternion x
            const qy = -this.array[curEl + 6]; // current quaternion y
            const qz = -this.array[curEl + 7]; // current quaternion z
            const qw = this.array[curEl + 8]; // current quaternion w

            this.array[curEl + 1] = qx * nqw  + qw * nqx + qy * nqz - qz * nqy; // delta qy
            this.array[curEl + 2] = qy * nqw  + qw * nqy + qz * nqx - qx * nqz; // delta qz
            this.array[curEl + 3] = qz * nqw  + qw * nqz + qx * nqy - qy * nqx; // delta qw
            this.array[curEl + 4] = qw * nqw  - qx * nqx - qy * nqy - qz * nqz; // delta qx
            

            if((log === true)&&(nb === 3)){
                console.log('q compute delta q : -'+(-qx.toFixed(2))+','+(-qy.toFixed(2))+','+(-qz.toFixed(2))+','+qw.toFixed(2)+' '+nqx.toFixed(2)+','+nqy.toFixed(2)+','+nqz.toFixed(2)+','+nqw.toFixed(2));
                console.log('q compute delta dq : '+this.array[curEl + 1] .toFixed(2)+','+this.array[curEl + 2] .toFixed(2)+','+this.array[curEl + 3] .toFixed(2)+','+this.array[curEl + 4] .toFixed(2));
            }
  
            this.array[curEl + 5] = nqx; // new quaternion x
            this.array[curEl + 6] = nqy; // new quaternion y
            this.array[curEl + 7] = nqz; // new quaternion z
            this.array[curEl + 8] = nqw; // new quaternion w
            this.array[curEl + 9] = life;
            if(life == 0){

                const npx = buffer[ofs++];
                const npy = buffer[ofs++];
                const npz = buffer[ofs++];
                
                this.array[curEl + 10] = this.array[curEl + 10] - npx; // new quaternion y
                this.array[curEl + 11] = this.array[curEl + 11] - npy; // new quaternion z
                this.array[curEl + 12] = this.array[curEl + 12] - npz; // new quaternion w
                    
                this.array[curEl + 13] = npx; // new quaternion y
                this.array[curEl + 14] = npy; // new quaternion z
                this.array[curEl + 15] = npz; // new quaternion w

            }
        }

        return ofs;
    }

    getInterpolatedValue(n, time , t, log = false){

        const curEl = n * 16;


        const qx = this.array[curEl + 5];
        const qy = this.array[curEl + 6];
        const qz = this.array[curEl + 7];
        const qw = this.array[curEl + 8];
        const life = this.array[curEl + 9];


        t.life=life;

        if(life === 0){
            const px = this.array[curEl + 13];
            const py = this.array[curEl + 14];
            const pz = this.array[curEl + 15];

            t.position.x = px;
            t.position.y = py; // delta qy
            t.position.z = pz; // delta qz
        }

        if(!this.active[n]){
            t.quaternion.set(qx,qy,qz,qw); // delta qw
            return false;
        }
     

        if((this.deltaTime<=0)||(time <= this.time)){
            t.quaternion.set(qx,qy,qz,qw);
            return true;
        }


        const dqx = this.array[curEl + 1];
        const dqy = this.array[curEl + 2];
        const dqz = this.array[curEl + 3];
        const dqw = this.array[curEl + 4];
        const dt = time - this.time;
        const fac = dt / this.deltaTime;
 
        if(fac > 1) {

            t.quaternion.x = qx * dqw  + qw * dqx + qy * dqz - qz * dqy; // delta qy
            t.quaternion.y = qy * dqw  + qw * dqy + qz * dqx - qx * dqz; // delta qz
            t.quaternion.z = qz * dqw  + qw * dqz + qx * dqy - qy * dqx; // delta qw
            t.quaternion.w = qw * dqw  - qx * dqx - qy * dqy - qz * dqz; // delta qx

            return true;
        }

        this.mq.set(qx, qy, qz, qw);
        this.dq.set(dqx, dqy, dqz, dqw);
        this.qf.multiplyQuaternions(this.mq , this.dq);
        this.q.slerpQuaternions(this.mq, this.qf, fac);
        /*
        const mq = new THREE.Quaternion(qx, qy, qz, qw);
        const qf= mq.clone().multiply(new THREE.Quaternion(dqx, dqy, dqz, dqw));
        const q= new THREE.Quaternion().slerpQuaternions(mq, qf, fac);
        */

        t.quaternion.set(this.q.x,this.q.y, this.q.z, this.q.w); // delta qw

        if((log === true)&&(n === 3)){

            const dt = time - this.time;
            const fac = dt / this.deltaTime;

            console.log('qcompute interp '+time.toFixed(2)+' '+this.time.toFixed(2)+' '+dt.toFixed(2)+' '+fac.toFixed(2));
        
            console.log('qcompute interp q : '+(qx.toFixed(2))+','+(qy.toFixed(2))+','+(qz.toFixed(2))+','+qw.toFixed(2)+' '+dqx.toFixed(2)+','+dqy.toFixed(2)+','+dqz.toFixed(2)+','+dqw.toFixed(2));
            console.log('qcompute interp dq : '+t.quaternion.x .toFixed(2)+','+t.quaternion.y.toFixed(2)+','+t.quaternion.z.toFixed(2)+','+t.quaternion.w.toFixed(2));
        }

        return true;
    }
}


export class ShotLerp{

    nElements;
    array;
    time;
    deltaTime;


    constructor(num, buffer, ofs, numElements, time){
        this.maxElements = num;
        this.nElements = numElements;
        this.time = time;
        this.deltaTime = 0;

        this.array = new Float32Array(this.maxElements * 8);
        this.cnt = 0;
        
        for(let n=0;n<this.nElements;n++){

            let curEl = n * 8; // 16 alignment

            this.array[curEl++] = buffer[ofs++]; // id

            this.array[curEl++] = 0.0; // delta px
            this.array[curEl++] = 0.0; // delta py
            this.array[curEl++] = 0.0; // delta pz

            this.array[curEl++] = buffer[ofs++]; // px
            this.array[curEl++] = buffer[ofs++]; // py
            this.array[curEl++] = buffer[ofs++]; // pz
        }
        
    }

    computeDelta(buffer, ofs, bufElements, time, log = false){

        if(time<=this.time){
            this.time = time;
            return ofs + bufElements * 4;
        }

            

        this.deltaTime = time - this.time;
        this.time = time;
        
        for(let nb = 0; nb< bufElements; nb++){
            const id = parseInt(buffer[ofs++]);
            const nx = buffer[ofs++];
            const ny = buffer[ofs++];
            const nz = buffer[ofs++];
            const targetOffset = nb * 8;

            let curEl = -1;

            for(let idx = 0; idx < this.nElements * 8; idx += 8){
                const eid = parseInt(this.array[ idx + 0]);
                if( eid == id) {
                    curEl = idx;
                    break;
                }
            }

            this.array[targetOffset + 0] = id; // id

            if(curEl >= 0){

                if(curEl < targetOffset){
                    continue;                    console.warn('error with id order '+nb + ' '+id+' '+curEl+' '+targetOffset);

                }
                                
                const x  = this.array[curEl + 4]; // current position x
                const y  = this.array[curEl + 5]; // current position y
                const z  = this.array[curEl + 6]; // current position z

                this.array[targetOffset + 1] = nx - x; // delta px
                this.array[targetOffset + 2] = ny - y; // delta py
                this.array[targetOffset + 3] = nz - z; // delta pz
            }else{

                this.array[targetOffset + 1] = 0; // delta px
                this.array[targetOffset + 2] = 0; // delta py
                this.array[targetOffset + 3] = 0; // delta pz
            }

            this.array[targetOffset + 4] = nx; // new position x
            this.array[targetOffset + 5] = ny; // new position y
            this.array[targetOffset + 6] = nz; // new position z

            
            if((log === true)&&(id === 3)){
                console.log('shot compute delta p : '+nx.toFixed(2)+','+ny.toFixed(2)+','+nz.toFixed(2)+' '+nx.toFixed(2)+','+ny.toFixed(2)+','+nz.toFixed(2));
                console.log('shot compute delta dp : '+this.array[curEl + 1] .toFixed(2)+','+this.array[curEl + 2] .toFixed(2)+','+this.array[curEl + 3] .toFixed(2));
            }
        }

        this.nElements = bufElements;



        return ofs;
    }

    getInterpolatedValue(id, time , t, delta = null, log = false){

        let curEl = -1;
        for(let idx = 0; idx < this.nElements * 8; idx += 8){
            const eid = parseInt(this.array[ idx + 0]);
            if( eid == id) {
                curEl = idx;
                break;
            }
        }

        if(curEl<0)
            return false;
        
        const dx = this.array[curEl + 1];
        const dy = this.array[curEl + 2];
        const dz = this.array[curEl + 3];

        tmpVec.set(dx, dy, dz).normalize();
        tmpQ.setFromUnitVectors(frontVec, tmpVec);

        t.quaternion.x = tmpQ.x;
        t.quaternion.y = tmpQ.y;
        t.quaternion.z = tmpQ.z;
        t.quaternion.w = tmpQ.w;

        const px = this.array[curEl + 4];
        const py = this.array[curEl + 5];
        const pz = this.array[curEl + 6];

        if(delta) {
            delta.set(dx,dy,dz);
        }

        if((this.deltaTime<=0)||(time <= this.time))
        {

            t.position.x = px;
            t.position.y = py;
            t.position.z = pz;
            return true;
        }

        const dt = time - this.time;
        const fac = Math.min(1.0, dt / this.deltaTime);
 
        t.position.x = px + dx * fac;
        t.position.y = py + dy * fac;
        t.position.z = pz + dz * fac;

        if((log === true)&&(curEl === 3)){

            console.log('compute interp '+time.toFixed(2)+' '+this.time.toFixed(2)+' '+dt.toFixed(2)+' '+fac.toFixed(2));
            console.log('compute interp p : '+px.toFixed(2)+','+py.toFixed(2)+','+pz.toFixed(2)+' '+dx.toFixed(2)+','+dy.toFixed(2)+','+dz.toFixed(2));
            console.log('compute interp np : '+t.position.x.toFixed(2)+','+t.position.y .toFixed(2)+','+t.position.z.toFixed(2));
        }

        return true;
    }
}


export class Transformation2 {
    angle;
    position;

    constructor(p = null, a = null) {

        this.m2 = new Array(4);
        this.angle = a ? a : 0;
        this.position  = p ? { x: p.x, y: p.y} : { x: 0, y: 0 };
        this.computeMatrix();
    }

    set(p, a = null) {

        if(p != null) {
            this.position.x = p.x;
            this.position.y = p.y;
        }

        if(a != null) {
            this.angle = a;
            this.computeMatrix();
        }
    }

    rotate(angle) {
        this.angle += angle;
        this.computeMatrix();
    }

    multiply(t, out) {
        const px = this.position.x + t.position.x;
        const py = this.position.y + t.position.y;
        
        out.position.x = px * this.m2[0] + py * this.m2[3];
        out.position.y = px * this.m2[1] + py * this.m2[4];
        out.angle = this.angle + t.angle;
        out.computeMatrix();
    }
    getInverse(o) { 
        
        o.position.x = -this.position.x;
        o.position.y = -this.position.y;
        o.position.z = -this.position.z;
        o.angle = - this.angle;
        o.computeMatrix();
    }
    toBuffer2(out, ofs = 0) {
        out[ofs + 0] = this.m2[0];
        out[ofs + 1] = this.m2[1];

        out[ofs + 2] = this.m2[2];
        out[ofs + 3] = this.m2[3];
    }

    toBuffer4(out, ofs = 0) {
        out[ofs + 0] = this.m2[0];
        out[ofs + 1] = this.m2[1];
        out[ofs + 2] = 0;
        out[ofs + 3] = 0;

        out[ofs + 4] = this.m3[2];
        out[ofs + 5] = this.m3[3];
        out[ofs + 6] = 0;
        out[ofs + 7] = 0;

        out[ofs + 8] = 0;
        out[ofs + 9] = 0;
        out[ofs + 10] = 1;
        out[ofs + 11] = 0;

        out[ofs + 12] = this.position.x;
        out[ofs + 13] = this.position.y;
        out[ofs + 14] = this.position.z;
        out[ofs + 15] = 1.0;
    }
    toBuffer(out, ofs = 0)
    {
        this.toBuffer2(out, ofs);
        out[ofs + 4] = this.position.x;
        out[ofs + 5] = this.position.y;
    }

    computeMatrix() {
        const c = Math.cos(this.angle);
        const s = Math.sin(this.angle);

        this.m2[0] = c;
        this.m2[1] = s;

        this.m2[2] = -s;
        this.m2[3] = c;
    }

    applyV(v) {
        const px = this.position.x + v.x;
        const py = this.position.y + v.y;

        return {x: (px * this.m2[0] + py * this.m2[2]),
                y: (px * this.m2[1] + py * this.m2[3])}
    }

    applyQV(v) {
        return {x: v.x * this.m2[0] + v.y * this.m2[2],
                y: v.x * this.m2[1] + v.y * this.m2[3]}
    }
    apply(g) {
        for (let v = 0; v < g.attributes.uv.array.length; v += 2) {
            const x = g.attributes.uv.array[v + 0];
            const y = g.attributes.uv.array[v + 1];
            
            g.attributes.uv.array[v + 0] = (x * this.m2[0] + y * this.m2[2]) + this.position.x;
            g.attributes.uv.array[v + 1] = (x * this.m2[1] + y * this.m2[3]) + this.position.y;
        }
    }

    applyQ(g) {
        for (let v = 0; v < g.attributes.uv.array.length; v += 3) {
            const x = g.attributes.uv.array[v + 0];
            const y = g.attributes.uv.array[v + 1];

            g.attributes.uv.array[v + 0] = x * this.m2[0] + y * this.m2[2];
            g.attributes.uv.array[v + 1] = x * this.m2[1] + y * this.m2[3];
        }
    }

}

export function glOrtho(M, l, r, b,  t, n, f)
{ 
    // set OpenGL perspective projection matrix
    M[0] = 2 / (r - l); 
    M[1] = 0; 
    M[2] = 0; 
    M[3] = 0; 
 
    M[4] = 0; 
    M[5] = 2 / (t - b); 
    M[6] = 0; 
    M[7] = 0; 
 
    M[8] = 0; 
    M[9] = 0; 
    M[10] = -2 / (f - n); 
    M[11] = 0; 
 
    M[12] = -(r + l) / (r - l); 
    M[13] = -(t + b) / (t - b); 
    M[14] = -(f + n) / (f - n); 
    M[15] = 1; 
} 